import React from 'react'
import { Container, FieldContainer, LabelSpan } from './styles'
import { message } from '~/services'
import { Inline } from '~/styles'

const npsResponseValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

interface LikertScaleProps extends React.HTMLAttributes<HTMLInputElement> {
  npsValue?: number
}

export const LikertScale = ({ npsValue, ...rest }: LikertScaleProps): JSX.Element => {
  return (
    <FieldContainer>
      <Container>
        {npsResponseValues.map(value => (
          <label key={value}>
            <input type="radio" value={value} checked={value === npsValue} {...rest} />
            <span>{value}</span>
          </label>
        ))}
      </Container>

      <Inline width="100%" justifyContent="space-between">
        <LabelSpan>{message('feedback.npsResponseLow')}</LabelSpan>
        <LabelSpan>{message('feedback.npsResponseHigh')}</LabelSpan>
      </Inline>
    </FieldContainer>
  )
}
